export default {
      id: "phone-v2-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "app/svg/sprite.svg#phone-v2",
      toString: function () {
        return this.url;
      }
    }